// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-form-maker__elements {
    padding-top: 10px;
}

.dynamic-form-maker__element{
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    padding: 25px;
    border-radius: 12px;
    margin-bottom: 25px;
}

.dynamic-form-maker__form-title .input-field-input {
    background-color: var(--white-color);
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
}

.dynamic-form-maker__form-title.input-field {
    margin: 18px 0 0 0;
}

.dynamic-form-maker__form-title .input-field-label {
    font-size: 14px; 
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
}

.dynamic-form-maker__question{
    display: flex;
    justify-content: space-between;
}
.dynamic-form-maker__question .input-field{
    margin: 0;
}
.dynamic-form-maker__question .input-field-input{
    font-size: 14px; 
}
.dynamic-form-maker__question .select-field {
    width: 50%;
    margin: 0;
}

.dynamic-form-maker__question .select-field .MuiInput-underline:before{
    border: none;
}

.dynamic-form-maker__question .select-field .MuiInput-underline:hover:not(.Mui-disabled):before{
    border: none;
}

.dynamic-form-maker__question .select-field-input{
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    font-size: 14px !important; 
    font-family: var(--secondary-font) !important;
}

.dynamic-form-maker__question .MuiSelect-select:focus {
    background-color: var(--white-color);
}

.dynamic-form-maker__options{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.dynamic-form-maker__options_switch{
    font-size: 14px; 
    font-family: var(--secondary-font);
}

.dynamic-form-maker__remove-element{
    color: var(--error-color);
    cursor: pointer;
}

.dynamic-form-maker__title.baloa-subtitle-2 {
    color: var(--primary-very-dark-color);
}

.dynamic-form-maker_description.baloa-table-column {
    color: var(--primary-dark-color);
    margin: 24px 0 16px 0;
}

.dynamic-form-maker__buttons {
    display: flex;
    justify-content: space-between;
    padding-bottom: 12px;
    margin-bottom: 24px;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.tournament-dynamic-form-maker__preview-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
}

.tournament-dynamic-form-maker__preview-btn .hubicon-preview {
    color: var(--new-green-color);
    font-size: var(--space-x2);
}

.tournament-dynamic-form-maker__preview-btn .baloa-table {
    color: var(--new-green-color);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-dynamic-form-maker/TournamentDynamicFormMakerComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,kDAAkD;IAClD,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,SAAS;AACb;AACA;IACI,eAAe;AACnB;AACA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;IAClD,0BAA0B;IAC1B,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,mBAAmB;IACnB,yDAAyD;AAC7D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".dynamic-form-maker__elements {\n    padding-top: 10px;\n}\n\n.dynamic-form-maker__element{\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    padding: 25px;\n    border-radius: 12px;\n    margin-bottom: 25px;\n}\n\n.dynamic-form-maker__form-title .input-field-input {\n    background-color: var(--white-color);\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.dynamic-form-maker__form-title.input-field {\n    margin: 18px 0 0 0;\n}\n\n.dynamic-form-maker__form-title .input-field-label {\n    font-size: 14px; \n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n}\n\n.dynamic-form-maker__question{\n    display: flex;\n    justify-content: space-between;\n}\n.dynamic-form-maker__question .input-field{\n    margin: 0;\n}\n.dynamic-form-maker__question .input-field-input{\n    font-size: 14px; \n}\n.dynamic-form-maker__question .select-field {\n    width: 50%;\n    margin: 0;\n}\n\n.dynamic-form-maker__question .select-field .MuiInput-underline:before{\n    border: none;\n}\n\n.dynamic-form-maker__question .select-field .MuiInput-underline:hover:not(.Mui-disabled):before{\n    border: none;\n}\n\n.dynamic-form-maker__question .select-field-input{\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    font-size: 14px !important; \n    font-family: var(--secondary-font) !important;\n}\n\n.dynamic-form-maker__question .MuiSelect-select:focus {\n    background-color: var(--white-color);\n}\n\n.dynamic-form-maker__options{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.dynamic-form-maker__options_switch{\n    font-size: 14px; \n    font-family: var(--secondary-font);\n}\n\n.dynamic-form-maker__remove-element{\n    color: var(--error-color);\n    cursor: pointer;\n}\n\n.dynamic-form-maker__title.baloa-subtitle-2 {\n    color: var(--primary-very-dark-color);\n}\n\n.dynamic-form-maker_description.baloa-table-column {\n    color: var(--primary-dark-color);\n    margin: 24px 0 16px 0;\n}\n\n.dynamic-form-maker__buttons {\n    display: flex;\n    justify-content: space-between;\n    padding-bottom: 12px;\n    margin-bottom: 24px;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.tournament-dynamic-form-maker__preview-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    cursor: pointer;\n}\n\n.tournament-dynamic-form-maker__preview-btn .hubicon-preview {\n    color: var(--new-green-color);\n    font-size: var(--space-x2);\n}\n\n.tournament-dynamic-form-maker__preview-btn .baloa-table {\n    color: var(--new-green-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
